'use client';
import classNames from 'classnames';
import { FC, Fragment } from 'react';

import { CartItem, CartItemExtended } from '@/entities/cart';
import { useCartStore } from '@/features/cart';
import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import { useModalStore } from '@/widgets/modals/model/store';
import ConfirmModal from '@/widgets/modals/ui/confirmModal/ConfirmModal';
import Modal from '@/widgets/modals/ui/modalWrapper/ModalWrapper';

import styles from './cartList.module.scss';
import CartListHeader from '../cartListHeader/CartListHeader';

interface CartListProps {
  items: CartItem[];
  className?: string;
}

const CartList: FC<CartListProps> = (props) => {
  const { items, className } = props;
  const { removeFromCart, adjustQuantity, updateCartItemPrice } =
    useCartStore();
  const { modal, closeModal } = useModalStore();

  const handleQuantityChange = (
    productId: number,
    priceId: number,
    delta: -1 | 1,
  ) => {
    adjustQuantity(productId, priceId, delta);
  };

  const handlePriceChange = (
    productId: number,
    oldPriceId: number,
    newPriceId: number,
  ) => {
    updateCartItemPrice(productId, oldPriceId, newPriceId);
  };

  const handleRemoveItem = (productId: number, priceId: number) => {
    removeFromCart(productId, priceId);
  };

  const handleRemoveUnavailableItems = () => {
    items.forEach((item) => {
      if (!item.selectedPrice.is_available) {
        removeFromCart(item.product.id, item.selectedPrice.id);
      }
    });
    closeModal();
  };

  function renderCartListItem(item: CartItem) {
    return (
      <Fragment key={`${item.product.id}-${item.selectedPrice.id}`}>
        <CartItemExtended
          item={item}
          onPriceChange={(newPriceId) =>
            handlePriceChange(
              item.product.id,
              item.selectedPrice.id,
              newPriceId,
            )
          }
          onQuantityChange={(newQuantity) =>
            handleQuantityChange(
              item.product.id,
              item.selectedPrice.id,
              newQuantity,
            )
          }
          onRemove={handleRemoveItem}
        />
      </Fragment>
    );
  }

  return (
    <div className={classNames(styles.wrapper, className)}>
      <CartListHeader />
      {items?.map(renderCartListItem)}
      {modal === MODAL_TYPES.confirmRemove && (
        <Modal>
          <ConfirmModal
            buttons={[
              { label: 'Да, удалить', onClick: handleRemoveUnavailableItems },
              {
                label: 'Нет, закрыть окно',
                onClick: closeModal,
              },
            ]}
            text="Чтобы продолжить оформление заказа, требуется удалить отсутствующие товары."
            title="Подтвердите действие"
          />
        </Modal>
      )}
    </div>
  );
};

export default CartList;
